import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Interactions from 'common/form/Interactions';
import { createReferralInteraction } from 'actions/Referral/Group';
import { INTERACTION_TYPES } from 'src/components/Notes/constants';
import {
  useInvalidateQueries,
} from 'src/api/APIHooks';

export const ReferralInteractions = (props) => {
  const {
    styles,
    referral,
    cancelFunction,
  } = props;
  const invalidateQueries = useInvalidateQueries();

  const submitAction = (formValues, category) => (
    props.createReferralInteraction({
      referralId: referral.id,
      interaction: {
        ...formValues.interaction,
        category,
      },
    }).then(() => {
      invalidateQueries('notes');
      cancelFunction();
    })
  );

  const submitOther = (formValues) => (
    submitAction(formValues, 'general')
  );

  const submitInteraction = (formValues) => (
    submitAction(formValues, 'interaction')
  );

  const interactionList = [
    { value: INTERACTION_TYPES.INTERACTION, submitFunction: submitInteraction },
    { value: INTERACTION_TYPES.GENERAL, submitFunction: submitOther },
  ];

  return (
    <div style={styles.position}>
      <Interactions
        detailType="referral"
        interactionList={interactionList}
        isFromCaseOrReferral
        cancelFunction={cancelFunction}
      />
    </div>
  );
};

ReferralInteractions.propTypes = {
  referral: PropTypes.object.isRequired,
  createReferralInteraction: PropTypes.func.isRequired,
  styles: PropTypes.object.isRequired,
  cancelFunction: PropTypes.func.isRequired,
};

ReferralInteractions.defaultProps = {
  styles: {
    position: { marginTop: '20px' },
  },
};

export default connect(null, { createReferralInteraction })(ReferralInteractions);
